import React from 'react';
import { bind } from 'bind-event-listener';
/**
 * If the user clicks outside of the modal
 * - if they have not entered any text we end the experience
 * - if they have entered text we move them to the discard screen
 * - if they click on the feedback form we do nothing
 */
export var useOutsideClickHandler = function useOutsideClickHandler(_ref) {
  var userInput = _ref.userInput,
    onCancel = _ref.onCancel,
    onDiscard = _ref.onDiscard,
    modalRef = _ref.modalRef;
  React.useEffect(function () {
    if (!modalRef) {
      return;
    }
    var handleOutsideClick = function handleOutsideClick(event) {
      // If the click is not inside the editor, do nothing
      // This is to prevent the user from accidentally closing the modal when they are trying to interact with other modals
      // or other elements on the page
      var editor = event.target.closest('.akEditor');
      if (!editor) {
        return;
      }
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (!userInput) {
          onCancel();
        } else {
          onDiscard();
        }
      }
    };
    var unbind = bind(document, {
      type: 'mousedown',
      listener: handleOutsideClick
    });
    return unbind;
  }, [userInput, onCancel, onDiscard, modalRef]);
};